import * as types from '../../mutation-types';

/**
 * Update viewport related data
 */
export function setViewport({ commit }, { width, height, mq }) {
    commit(types.SET_VIEWPORT, { width, height, mq });
}

export function setPageVisibility({ commit }, { hidden }) {
    commit(types.SET_PAGE_VISIBILITY, { hidden });
}
